<template>
  <div>
  <v-col cols="8" sm="12" md="12" xs="12" lg="8" xl="8">
      <v-text-field class="pr-3"
        label="Traži prema pojmu u razini 6"
        v-model="uvjet"
        outlined
        @keydown.enter="traziPo"
      ></v-text-field> 
  </v-col>
  <div v-if="showData"> 
   <v-card outlined>
        <v-card-title>
          Razina 6
        </v-card-title>
        
          <v-data-table
              :headers="headers"
              :items="razItems"
              :search="search"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50]
              }"
              :items-per-page="30"
              item-key="id"
              @click:row="navigateTo"
            >
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
       
      </v-card>
    </div>

    <v-dialog v-model="dialog" max-width="600px">

          <v-card>
            <v-card-title>
              <span class="headline">Detalji</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                >
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 1: <span style="font-weight:bold">{{ itemDetail.Razina1 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                     {{ itemDetail.Hrv1 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 2: <span style="font-weight:bold">{{ itemDetail.Razina2 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                      {{ itemDetail.Hrv2 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 3:<span style="font-weight:bold">{{ itemDetail.Razina3 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                      {{ itemDetail.Hrv3 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 4: <span style="font-weight:bold">{{ itemDetail.Razina4 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                      {{ itemDetail.Hrv4 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 5: <span style="font-weight:bold">{{ itemDetail.Razina5 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                      {{ itemDetail.Hrv5 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Razina 6: <span style="font-weight:bold">{{ itemDetail.Razina6 }}</span>
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                      {{ itemDetail.Hrv6 }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="pr-1">
                      Potpuna Sifra:
                    </v-col>
                    <v-col cols="12" sm="9" md="9" xs="9" lg="9" xl="9" class="pr-1">
                       <span style="font-weight:bold">{{ itemDetail.PotpunaSifra }}</span>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-spacer></v-spacer>
                    <v-btn color="success"  @click="dialogSwitch">OK</v-btn>  
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>
 
          </v-card>
    </v-dialog>
  </div>
</template>

<script>

import KlasusService from '@/services/KlasusService'

export default {
  name: 'klasusindex',
  data () {
    return {
      uvjet: '',
      razUpit: {
        onLevel: 7
      },
      showData: false,
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [],
      showDetail: false,
      itemDetail: {},
      dialog: false
    }
  },
  mounted () {
    this.headers.push(
      { text: 'Opis 6', align: 'left', value: 'Hrv6' },
      {
        text: 'Potpuna Sifra',
        align: 'left',
        sortable: true,
        value: 'PotpunaSifra'
      },
      { text: 'Raz.6', align: 'left', value: 'Razina6' },
      { text: 'Raz.5', align: 'left', value: 'Razina5' },
      { text: 'Raz.4', align: 'left', value: 'Razina4' },
      { text: 'Raz.3', align: 'left', value: 'Razina3' },
      { text: 'Raz.2', align: 'left', value: 'Razina2' },
      { text: 'Raz.1', align: 'left', value: 'Razina1' },
      { text: 'DbId', value: 'id' }
    )
  },
  methods: {
    async traziPo() {
      this.razUpit.Hrv6 = this.uvjet.trim()
      this.showData = false
      if (this.uvjet.trim().length > 0) {
        await KlasusService.choose(this.razUpit).then(res => {
          if (res.data.klasusData) {
            this.razItems = res.data.klasusData
            this.showData = true
          }
        })
        .catch(err => {
          this.havealert = !this.havealert
          this.havemssgalert = 'Error on init Klasus Level 1 ' + err
        })
      }

    },
    navigateTo(item) {
      this.showDetail = true
      this.itemDetail = item
      this.dialogSwitch()
    },
    dialogSwitch() {
      this.dialog = !this.dialog
    }

  },
  computed: {

  },
  watch: {

  },
  components: {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
